/* PHASES desktop mega menu.
   Wires the header "Menu" trigger(s) to the <phases-mega-menu> panel rendered by
   snippets/phases-mega-menu.liquid. Loaded only when the header setting
   `enable_phases_menu` is on. */
(function () {
  "use strict";

  if (customElements.get("phases-mega-menu")) return;

  var OPEN = "is-open";
  var WRAPPER_OPEN = "phases-menu--open";
  var MEGANAV = "meganav--visible"; /* theme class: flips transparent header solid */
  var SCROLL_CLOSE_DELTA = 40;

  class PhasesMegaMenu extends HTMLElement {
    constructor() {
      super();
      this.isOpen = false;
      this._scrollY = 0;
      this._onDocPointer = this._onDocPointer.bind(this);
      this._onKeydown = this._onKeydown.bind(this);
      this._onScroll = this._onScroll.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onPanelClick = this._onPanelClick.bind(this);
    }

    connectedCallback() {
      this.wrapper = this.closest("[data-header-wrapper]") || this.closest(".header__wrapper") || null;

      var scope = this.wrapper || document;
      this.triggers = Array.prototype.slice
        .call(scope.querySelectorAll("[data-phases-menu-trigger]"))
        .filter(function (btn) {
          return !btn.closest(".js__header__clone");
        });

      var self = this;
      this.triggers.forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          self.toggle();
        });
      });

      this.addEventListener("click", this._onPanelClick);
    }

    disconnectedCallback() {
      this._unbind();
      this.removeEventListener("click", this._onPanelClick);
    }

    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.show();
      }
    }

    show() {
      if (this.isOpen) return;
      this.isOpen = true;
      this.classList.add(OPEN);
      this.triggers.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "true");
      });
      if (this.wrapper) this.wrapper.classList.add(WRAPPER_OPEN, MEGANAV);

      this._scrollY = window.scrollY || window.pageYOffset || 0;
      document.addEventListener("click", this._onDocPointer, true);
      document.addEventListener("keydown", this._onKeydown);
      window.addEventListener("scroll", this._onScroll, { passive: true });
      window.addEventListener("resize", this._onResize);
      window.addEventListener("theme:resize:width", this._onResize);
    }

    close() {
      if (!this.isOpen) return;
      this.isOpen = false;
      this.classList.remove(OPEN);
      this.triggers.forEach(function (btn) {
        btn.setAttribute("aria-expanded", "false");
      });
      if (this.wrapper) this.wrapper.classList.remove(WRAPPER_OPEN, MEGANAV);
      this._unbind();
    }

    _unbind() {
      document.removeEventListener("click", this._onDocPointer, true);
      document.removeEventListener("keydown", this._onKeydown);
      window.removeEventListener("scroll", this._onScroll);
      window.removeEventListener("resize", this._onResize);
      window.removeEventListener("theme:resize:width", this._onResize);
    }

    _onPanelClick(event) {
      /* Any link inside the panel closes it (navigation follows). */
      if (event.target.closest("a[href]")) this.close();
    }

    _onDocPointer(event) {
      if (this.contains(event.target)) return;
      var onTrigger = this.triggers.some(function (btn) {
        return btn.contains(event.target);
      });
      if (onTrigger) return;
      this.close();
    }

    _onKeydown(event) {
      if (event.key === "Escape" || event.key === "Esc") {
        this.close();
        if (this.triggers[0]) this.triggers[0].focus();
      }
    }

    _onScroll() {
      var y = window.scrollY || window.pageYOffset || 0;
      if (Math.abs(y - this._scrollY) > SCROLL_CLOSE_DELTA) this.close();
    }

    _onResize() {
      if (window.innerWidth < 750) this.close();
    }
  }

  customElements.define("phases-mega-menu", PhasesMegaMenu);
})();
